module.exports = __webpack_public_path__ + "img/avatar3.326f0698.png";